// Auto-play videos when they become the active slide in the product media gallery
(function () {
  function handleSlideChange(mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        const slide = mutation.target;
        // Slide just became visible
        if (slide.getAttribute('aria-hidden') === 'false') {
          const deferredMedia = slide.querySelector('deferred-media');
          if (deferredMedia) {
            // Only auto-play if it's a video (not a 3D model)
            const isModel = slide.closest('product-model') || deferredMedia.querySelector('model-viewer');
            if (!isModel) {
              // Small delay to let the slide transition finish
              setTimeout(function () {
                if (typeof deferredMedia.showDeferredMedia === 'function') {
                  deferredMedia.showDeferredMedia();
                } else {
                  deferredMedia.loadContent && deferredMedia.loadContent(false);
                }
              }, 100);
            }
          }
        }
      }
    });
  }

  function observeGallery() {
    document.querySelectorAll('media-gallery slideshow-slide').forEach(function (slide) {
      const observer = new MutationObserver(handleSlideChange);
      observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGallery);
  } else {
    observeGallery();
  }

  // Re-run if the gallery is replaced (e.g. variant change)
  const bodyObserver = new MutationObserver(function () {
    observeGallery();
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
